<template>
  <NuxtLink
    :to="goToRoute"
    v-bind="$attrs"
    :class="{ 'cursor-default': !to && !noLinkPointer }"
    @click="$emit('link-click', $event)"
  >
    <slot />
  </NuxtLink>
</template>

<script lang="ts">

export default defineComponent({
  name: 'SimpleLink',
  props: {
    to: {
      type: String,
      required: true,
    },
    noLinkPointer: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['link-click'],
  setup(props: { to: string }) {

    const { addPrefixToSlugIfNecessary } = usePrefix();
    const goToRoute = computed(() => addPrefixToSlugIfNecessary(props.to));

    return {
      goToRoute,
    };

  },
});
</script>

<style lang="scss" scoped>
.cursor-default {
  cursor: default;
}
</style>
